<div class="login-dialog">
  <h4 class="alterar-senha-title" id="change-password-title">Alterar senha</h4>
  <form
    class="alterar-senha-form login-dialog__body"
    autocomplete="off"
    (input)="clearMessage()"
    (keydown.enter)="confirmFromEnter($event)"
  >
    <p class="alterar-senha-form__hint">
      Preencha os campos abaixo. A nova senha deve conter letras e números.
    </p>

    <div class="alterar-senha-form__field">
      <label for="change-password-current" class="alterar-senha-form__label">
        <span class="material-symbols-outlined" aria-hidden="true">lock</span>
        Senha atual
      </label>
      <div class="alterar-senha-form__input-wrap">
        <input
          #currentPasswordInput
          id="change-password-current"
          class="alterar-senha-form__input"
          placeholder="Digite sua senha atual"
          aria-label="Senha atual"
          autocomplete="current-password"
          [type]="visible.atual ? 'text' : 'password'"
          [formControl]="senhaAtual"
        />
        <button
          type="button"
          class="alterar-senha-form__toggle"
          [attr.aria-label]="visible.atual ? 'Ocultar senha' : 'Mostrar senha atual'"
          (click)="toggle('atual')"
        >
          <span class="material-symbols-outlined" aria-hidden="true">
            {{ visible.atual ? 'visibility_off' : 'visibility' }}
          </span>
        </button>
      </div>
    </div>

    <div class="alterar-senha-form__field">
      <label for="change-password-new" class="alterar-senha-form__label">
        <span class="material-symbols-outlined" aria-hidden="true">key</span>
        Nova senha
      </label>
      <div class="alterar-senha-form__input-wrap">
        <input
          id="change-password-new"
          class="alterar-senha-form__input"
          placeholder="Digite a nova senha"
          aria-label="Nova senha"
          autocomplete="new-password"
          [type]="visible.nova ? 'text' : 'password'"
          [formControl]="novaSenha"
          [class.is-valid]="rules().novaValid"
          [class.is-invalid]="rules().novaInvalid"
        />
        <button
          type="button"
          class="alterar-senha-form__toggle"
          [attr.aria-label]="visible.nova ? 'Ocultar senha' : 'Mostrar nova senha'"
          (click)="toggle('nova')"
        >
          <span class="material-symbols-outlined" aria-hidden="true">
            {{ visible.nova ? 'visibility_off' : 'visibility' }}
          </span>
        </button>
      </div>
    </div>

    <div class="alterar-senha-form__field">
      <label for="change-password-repeat" class="alterar-senha-form__label">
        <span class="material-symbols-outlined" aria-hidden="true">verified_user</span>
        Confirmar nova senha
      </label>
      <div class="alterar-senha-form__input-wrap">
        <input
          id="change-password-repeat"
          class="alterar-senha-form__input"
          placeholder="Repita a nova senha"
          aria-label="Confirmar nova senha"
          autocomplete="new-password"
          [type]="visible.repetir ? 'text' : 'password'"
          [formControl]="repetirSenha"
          [class.is-valid]="rules().repetirValid"
          [class.is-invalid]="rules().repetirInvalid"
        />
        <button
          type="button"
          class="alterar-senha-form__toggle"
          [attr.aria-label]="
            visible.repetir ? 'Ocultar senha' : 'Mostrar confirmação de senha'
          "
          (click)="toggle('repetir')"
        >
          <span class="material-symbols-outlined" aria-hidden="true">
            {{ visible.repetir ? 'visibility_off' : 'visibility' }}
          </span>
        </button>
      </div>
    </div>

    <ul class="alterar-senha-form__rules" aria-live="polite">
      <li
        class="alterar-senha-form__rule"
        [class.is-valid]="rules().letter === true"
        [class.is-invalid]="rules().letter === false"
      >
        <span class="material-symbols-outlined" aria-hidden="true">{{
          ruleIcon(rules().letter)
        }}</span>
        Contém letras
      </li>
      <li
        class="alterar-senha-form__rule"
        [class.is-valid]="rules().number === true"
        [class.is-invalid]="rules().number === false"
      >
        <span class="material-symbols-outlined" aria-hidden="true">{{
          ruleIcon(rules().number)
        }}</span>
        Contém números
      </li>
      <li
        class="alterar-senha-form__rule"
        [class.is-valid]="rules().match === true"
        [class.is-invalid]="rules().match === false"
      >
        <span class="material-symbols-outlined" aria-hidden="true">{{
          ruleIcon(rules().match)
        }}</span>
        Senhas coincidem
      </li>
    </ul>
  </form>

  @if (validationMessage) {
    <p class="login-dialog__message" role="alert">{{ validationMessage }}</p>
  }

  <div class="login-dialog__actions">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
      Cancelar
    </button>
    <button type="button" class="btn btn-ergon btn-shadow" (click)="confirm()">
      Salvar senha
    </button>
  </div>
</div>
